import * as Yup from 'yup'
import {ICorporateModel} from '../../admin/corporate/CorporateModel'

export const HR_COMPANY_PATH = '/hr/company'

export const EMPLOYEE_COUNT_OPTIONS = ['1-10', '11-50', '51-100', '100+', '500+', '1000+']

/** PATCH /corporate/profile gövdesi */
export interface ICompanyProfileRequest {
  tagline: string
  about: string
  industry: string
  employeeCount: string
  country: string
  website: string
  linkedinUrl: string
  termsUrl: string
  privacyUrl: string
  logoDocumentId: string
  headerDocumentId: string
}

const urlField = Yup.string()
  .trim()
  .max(255, 'En fazla 255 karakter')
  .matches(/^https?:\/\/\S+$/i, {message: 'http:// veya https:// ile başlamalıdır', excludeEmptyString: true})

export const validationCompanyProfile = Yup.object().shape({
  tagline: Yup.string().trim().max(255, 'En fazla 255 karakter'),
  about: Yup.string().trim().max(10000, 'En fazla 10000 karakter'),
  industry: Yup.string().trim().max(150, 'En fazla 150 karakter'),
  country: Yup.string().trim().max(100, 'En fazla 100 karakter'),
  website: urlField,
  linkedinUrl: urlField,
  termsUrl: urlField,
  privacyUrl: urlField,
})

export const toCompanyProfileForm = (corporate: ICorporateModel): ICompanyProfileRequest => ({
  tagline: corporate.tagline ?? '',
  about: corporate.about ?? '',
  industry: corporate.industry ?? '',
  employeeCount: corporate.employeeCount ?? '',
  country: corporate.country ?? '',
  website: corporate.website ?? '',
  linkedinUrl: corporate.linkedinUrl ?? '',
  termsUrl: corporate.termsUrl ?? '',
  privacyUrl: corporate.privacyUrl ?? '',
  logoDocumentId: corporate.logoDocumentId ?? '',
  headerDocumentId: corporate.headerDocumentId ?? '',
})
